import {
  FontSizes,
  FontWeights,
  getTheme,
  IBreadcrumbStyles,
  IButtonStyles,
  IIconProps,
  IStackStyles,
  mergeStyleSets,
} from "@fluentui/react";

export const theme = getTheme();
export const ChevronRight: IIconProps = { iconName: "CaretRightSolid8", style: { fontSize: "12px" } };
export const ChevronDown: IIconProps = { iconName: "CaretDownSolid8", style: { fontSize: "12px" } };
export const list: IIconProps = { iconName: "NumberedListText", style: { fontSize: "12px" } };
export const emojiIcon: IIconProps = { iconName: "Emoji2" };
export const buttonStyles = { root: { marginRight: 8 } };

// const siteStyles: IButtonStyles = { root: { fontSize: FontSizes.mediumPlus, fontWeight: FontWeights.semibold, color: theme.palette.themePrimary } }
// const docsStyles: IButtonStyles = { root: { fontSize: FontSizes.medium, fontWeight: FontWeights.regular, color: theme.palette.themeSecondary } }
export const folderStyles: IButtonStyles = {
  root: { fontSize: FontSizes.small, fontWeight: FontWeights.semilight, color: theme.palette.themeTertiary },
};
export const breadStyles: IBreadcrumbStyles = {
  root: { fontSize: FontSizes.medium, fontWeight: FontWeights.regular, color: theme.palette.themePrimary },
  list: { fontSize: FontSizes.medium, fontWeight: FontWeights.regular, color: theme.palette.themePrimary },
  listItem: { fontSize: FontSizes.medium, fontWeight: FontWeights.regular, color: theme.palette.themePrimary },
  chevron: { fontSize: FontSizes.medium, fontWeight: FontWeights.regular, color: theme.palette.themePrimary },
  overflow: { fontSize: FontSizes.mediumPlus, fontWeight: FontWeights.semibold, color: theme.palette.themePrimary },
  overflowButton: {
    fontSize: FontSizes.mediumPlus,
    fontWeight: FontWeights.semibold,
    color: theme.palette.themePrimary,
  },
  itemLink: { fontSize: FontSizes.medium, fontWeight: FontWeights.regular, color: theme.palette.themePrimary },
  item: { fontSize: FontSizes.mediumPlus, fontWeight: FontWeights.semibold, color: theme.palette.themePrimary },
};
export const stackStyles: Partial<IStackStyles> = { root: { height: 20 } };
export const styles2 = mergeStyleSets({
  callout: { width: "100%", height: 400, padding: "10px", border: "1" },
  title: { marginBottom: 12, fontWeight: FontWeights.semilight },
  buttons: { display: "flex", justifyContent: "flex-end", marginTop: 20 },
});
export const CalendarStyles = mergeStyleSets({
  root: { selectors: { "> *": { marginBottom: 15 } } },
  control: { maxWidth: 300, marginBottom: 15 },
});
export const classNames = mergeStyleSets({
  fileIconHeaderIcon: {
    padding: 0,
    fontSize: "16px",
  },
  fileIconCell: {
    textAlign: "center",
    selectors: {
      "&:before": {
        content: ".",
        display: "inline-block",
        verticalAlign: "middle",
        height: "100%",
        width: "0px",
        visibility: "hidden",
      },
    },
  },
  fileIconImg: {
    verticalAlign: "middle",
    maxHeight: "16px",
    maxWidth: "16px",
  },
  controlWrapper: {
    display: "flex",
    flexWrap: "wrap",
  },
  exampleToggle: {
    display: "inline-block",
    marginBottom: "10px",
    marginRight: "30px",
  },
  selectionDetails: {
    marginBottom: "20px",
  },
});

export const parseDate = (dateString) => {
  const [datePart, timePart] = dateString.split(", ");
  const [day, month, year] = datePart.split("/");
  return new Date(`${year}-${month}-${day}T${timePart}`);
};
